import { useContext, useEffect, useState } from 'react'
import { Data } from '@styled-icons/boxicons-solid'
import Tooltip from '../../../common/tooltip'
import {
  FunctionalDiagramEditContext,
  SET_CIRCUIT_PINS,
} from './context/context'
import { formatEmptyValue } from '../../../../utils/common'
import CheckBox from '../../../common/CheckBox'

const ComponentSearchDevicePins = (props) => {
  const [state, dispatch] = useContext(FunctionalDiagramEditContext)
  const [connectorsData, setConnectorsData] = useState({})

  const formatConnectorsData = () => {
    let tempConnectorData = {}
    state?.selectedSectionRecord?.data?.forEach((section, index) => {
      let connector = section?.['connector_from']
      if (section?.connector_to.startsWith(state.selectedSectionRecord.name)) {
        connector = section?.['connector_to']
      }
      let dataObj = {
        circuit_desc: section?.circuit_desc,
        color: section?.color,
        circuit_name: section?.circuit_name,
        pin_from: section?.pin_from,
        circuit_id: section?.circuit_id,
      }
      if (!(connector in tempConnectorData)) {
        tempConnectorData[connector] = [dataObj]
      } else {
        tempConnectorData[connector].push(dataObj)
      }
    })
    setConnectorsData(tempConnectorData)
  }

  useEffect(() => {
    if (state?.selectedSectionRecord?.data?.length > 0) {
      formatConnectorsData()
    }
  }, [state?.selectedSectionRecord?.data])

  return (
    <div className="bg-white rounded">
      <div className="font-semibold">
        <div className="flex flex-row w-full rounded-t-lg text-black text-sm border-b border-gray-500 py-2">
          <div className="flex w-1/12 pl-2 items-center"></div>
          <div className="flex w-11/12 pl-2 items-center">
            <div className="flex w-1/12 pl-1 items-center"></div>
            <div className="flex w-2/12 pl-6 items-center">Circuit</div>
            <div className="flex w-2/12 pl-6 items-center">Pin</div>
            <div className="flex w-2/12 pl-6 items-center">Color</div>
            <div className="flex w-4/12 pl-6 items-center">Description</div>
          </div>
        </div>
      </div>
      <div style={{ maxHeight: '60vh', overflowY: 'scroll' }}>
        {Object.keys(connectorsData).map((connector, index) => {
          let sectionsData = connectorsData[connector]
          return (
            <div
              key={`device-pin-connector-${connector}`}
              className="w-full border-b border-gray-500 text-black text-sm"
            >
              <div className="flex w-full py-2 items-center font-semibold border-b border-gray-500">
                {connector}
              </div>
              <div className="flex w-full">
                <div className="flex w-1/12 pl-2 items-center"></div>
                <div className="w-11/12 pl-2 items-center">
                  {sectionsData.map((section, sectionIndex) => {
                    let circuitPin = state.selectedCircuitPins?.includes(
                      `${section?.circuit_id}**$$${section?.pin_from}**$$${connector}`
                    )
                    return (
                      <div
                        key={`device-pin-circuit-${circuitPin}-${connector}-${sectionIndex}`}
                        className={`flex flex-row flex-wrap ${sectionIndex != sectionsData?.length - 1 && 'border-b'} border-gray-500 items-center w-full py-2 text-black text-sm`}
                      >
                        <div className="flex flex-row w-full">
                          <div className="flex w-1/12 pl-1 items-center table_text">
                            <CheckBox
                              value={circuitPin}
                              checked={circuitPin}
                              onChange={(value) => {
                                dispatch({
                                  type: SET_CIRCUIT_PINS,
                                  data: `${section?.circuit_id}**$$${section?.pin_from}**$$${connector}`,
                                  startConnectors: connector,
                                })
                              }}
                            />
                          </div>

                          <div className="flex w-2/12 pl-6 items-center table_text">
                            <Tooltip
                              position={'top'}
                              message={section?.circuit_name}
                            >
                              <div>
                                {formatEmptyValue(section?.circuit_name)}
                              </div>
                            </Tooltip>
                          </div>
                          <div className="flex w-2/12 pl-6 items-center table_text">
                            <Tooltip
                              position={'top'}
                              message={section?.pin_from}
                            >
                              <div>{formatEmptyValue(section?.pin_from)}</div>
                            </Tooltip>
                          </div>
                          <div className="flex w-2/12 pl-6 items-center table_text">
                            <Tooltip position={'top'} message={section?.color}>
                              <div>{formatEmptyValue(section?.color)}</div>
                            </Tooltip>
                          </div>
                          <div className="flex w-3/12 pl-6 items-center table_text">
                            <div>{formatEmptyValue(section?.circuit_desc)}</div>
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          )
        })}
        {state?.selectedSectionRecord?.data?.length == 0 && (
          <div className="flex justify-center h-100 py-6 items-center">
            No Data Found <Data size="2rem" color="gray" />
          </div>
        )}
      </div>
    </div>
  )
}

export default ComponentSearchDevicePins
